const FOCUSABLE_SELECTOR =
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

export const firstFocusableChild = (root: HTMLElement) => {
    return root.querySelector(FOCUSABLE_SELECTOR) as HTMLElement | null;
};
